/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ManualEmailStepBodyDoc } from './manualEmailStepBodyDoc';
import type { ManualEmailStepPriority } from './manualEmailStepPriority';
import type { ManualEmailStepSubjectDoc } from './manualEmailStepSubjectDoc';
import type { ManualEmailStepSubjectMode } from './manualEmailStepSubjectMode';
import type { ManualEmailStepThreadMode } from './manualEmailStepThreadMode';
import type { StepScheduleDelay } from './stepScheduleDelay';
import type { StepScheduleImmediate } from './stepScheduleImmediate';
import type { StepScheduleSoonestAt } from './stepScheduleSoonestAt';

export interface ManualEmailStep {
  schedule: StepScheduleImmediate | StepScheduleSoonestAt | StepScheduleDelay;
  priority?: ManualEmailStepPriority;
  subject_mode: ManualEmailStepSubjectMode;
  subject_doc?: ManualEmailStepSubjectDoc;
  body_doc: ManualEmailStepBodyDoc;
  thread_mode?: ManualEmailStepThreadMode;
  /** @maxItems 20 */
  cc?: string[];
  /** @maxItems 20 */
  bcc?: string[];
  include_sender_signature?: boolean;
  include_unsubscribe_link?: boolean;
  type: 'manual_email';
}
